import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHandlingUnauthorized } from '@ui/src';

const api = createApi({
  reducerPath: 'amlApi',
  baseQuery: baseQueryWithHandlingUnauthorized(process.env.API_HOST as string),
  tagTypes: ['AML'],
  endpoints: () => ({}),
});

export default api;
